import axios from "axios";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Game } from "speakid-city-speaking-game";
import "speakid-city-speaking-game/style.css";

import Config from "../../Config";
import PersonalDefaultPage from "../personal/PersonalDefaultPage";

export default function TalkQuest() {
  const navigate = useNavigate();

  const baseURL =
    typeof window !== "undefined" ? "/cloud/speakid/games/talk-quest/" : "";

  useEffect(() => {
    axios
      .get(Config.BACKEND_ADDR + "/payments/getSubscriptionPeriod")
      .then((res) => {
        if (res.status === 200 && res.data.status === "not_paid") {
          navigate("/billing/");
        }
      })
      .catch(() => {});
  }, [navigate]);

  return (
    <PersonalDefaultPage>
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "100%",
          overflow: "hidden",
        }}
      >
        <Game theme="city" baseURL={baseURL} showLogo />
      </div>
    </PersonalDefaultPage>
  );
}
